<template>
  <div class="search">
    <span>年份</span>
    <div class="select-time">
      <el-dropdown trigger="click" @command="onSelectTime">
        <span class="text">
          {{ year ? year + "年" : "全部" }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="">全部</el-dropdown-item>
          <el-dropdown-item command="2022">2022年</el-dropdown-item>
          <el-dropdown-item command="2021">2021年</el-dropdown-item>
          <el-dropdown-item command="2020">2020年</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-input @keydown.enter="$emit('select')" placeholder="请输入关键字搜索" v-model="titleValue" style="width: 400px">
      <!-- <i @click="$emit('select')" slot="suffix" class="el-input__icon el-icon-search"></i> -->
    </el-input>
    <el-button @click="$emit('select')">查询</el-button>
  </div>
</template>
<script>
export default {
  props: ["year", "title"],
  data() {
    return {};
  },
  computed: {
    titleValue: {
      set(v) {
        this.$emit("update:title", v);
      },
      get() {
        return this.$props.title;
      },
    },
  },
  methods: {
    onSelectTime(t) {
      this.$emit("update:year", t);
      this.$emit('select')
    },
  },
};
</script>

<style scoped lang="less">
.search {
    margin-top: 20px;
    width: 1200px;
    height: 70px;
    background-color: rgba(247, 247, 247, 1);
    padding-left: 39px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    > span {
      color: rgba(16, 16, 16, 1);
      font-size: 16px;
    }
    .select-time {
      padding-left: 169px;
      flex: 1;
      .text {
        cursor: pointer;
        color: rgba(16, 16, 16, 1);
        font-size: 14px;
      }
    }
  }
</style>